import { action, makeObservable, observable } from 'mobx'

import MapViewItemsSetupStore from '~/client/src/desktop/views/ProjectSetUp/components/AppsSitemap/stores/MapViewItemsSetup.store'
import MapViewItemBase from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemBase'
import HierarchyNode from '~/client/src/shared/models/HierarchyNode'

export default class HierarchyTreeNodeStore {
  @observable public isNodeHovering: boolean = false
  @observable public isGroupToggleHovering: boolean = false
  @observable public isObjectToggleHovering: boolean = false
  @observable public hoveredNode: HierarchyNode = null

  public constructor(
    private readonly mapViewItemsSetupStore: MapViewItemsSetupStore,
    private node: HierarchyNode,
  ) {
    makeObservable(this)
  }

  public get isNodeSelected(): boolean {
    return (
      !this.node.isSite &&
      this.mapViewItemsSetupStore.isMapViewItemSelected(this.node.item)
    )
  }

  public get groupItems(): MapViewItemBase[] {
    return this.node.groupNodes.map(n => n.item).filter(i => i)
  }

  public get isGroupDisplayed(): boolean {
    if (!this.node.hasChildren) {
      return false
    }

    return this.groupItems.every(i => i.isDisplayed)
  }

  public get lastNodeOfGroupId(): string {
    if (!this.node.isGroupToggleHovering) {
      return ''
    }

    const { groupNodes } = this.node
    return groupNodes[groupNodes.length - 1].nodeId
  }

  @action.bound
  public setNode(node: HierarchyNode) {
    this.node = node
  }

  @action.bound
  public setNodeHovering(node: HierarchyNode) {
    this.isNodeHovering = true
    this.mapViewItemsSetupStore.hoveredNode = node
  }

  @action.bound
  public resetNodeHovering() {
    this.isNodeHovering = false
    this.mapViewItemsSetupStore.hoveredNode = null
  }

  @action.bound
  public setGroupToggleHovering() {
    this.isGroupToggleHovering = true
  }

  @action.bound
  public resetGroupToggleHovering() {
    this.isGroupToggleHovering = false
  }

  @action.bound
  public setObjectToggleHovering() {
    this.isObjectToggleHovering = true
  }

  @action.bound
  public resetObjectToggleHovering() {
    this.isObjectToggleHovering = false
  }

  @action.bound
  public toggleItemsGroup() {
    if (!this.isUpdatingSitemapLoaderShown) {
      this.mapViewItemsSetupStore.toggleItemsVisibility(
        this.groupItems,
        this.isGroupDisplayed,
      )
    }
  }

  @action.bound
  public toggleItem() {
    if (!this.node.isSite && !this.isUpdatingSitemapLoaderShown) {
      this.mapViewItemsSetupStore.toggleSingleItemVisibility(this.node.item)
    }
  }

  @action.bound
  public selectItem(
    event: React.SyntheticEvent<HTMLDivElement>,
    item?: MapViewItemBase,
  ) {
    event.stopPropagation()

    if (!this.node.isSite) {
      this.mapViewItemsSetupStore.selectMapViewItem(item || this.node.item)
    }
  }

  public get isUpdatingSitemapLoaderShown(): boolean {
    return this.mapViewItemsSetupStore.isUpdatingSitemapLoaderShown
  }
}
